import React from "react";
import { Typography, Grid } from "@material-ui/core";
import "moment/locale/pt-br";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

//css
import StylesCss from "./styles";
import { Paper } from "@material-ui/core";
const useStyles = StylesCss();

export default function CardCollapseList(element) {
    const classes = useStyles();
    return (
        <Paper className={classes.card}>
            <Grid container item spacing={3} xs={12}>
                <Grid item xs={1}>
                    <FontAwesomeIcon className={classes.icon} icon={faCheck} />
                </Grid>

                <Grid item xs={6}>
                        <Typography variant="h6">
                            {element.NM_PROD}
                        </Typography>

                        <Typography variant="body2">
                            <strong>Número do pedido: </strong>
                            {element.NR_PC}
                            <br />
                        </Typography>

                        <Typography variant="body2">
                            <strong>ID do produto: </strong>
                            {element.ID_PROD}
                        </Typography>

                        <Typography variant="body2">
                            <strong>Filial: </strong>
                            {element.NM_FIL}
                        </Typography>
                </Grid>
                
                <Grid item xs={5}>
                        <Typography variant="body2">
                            <strong>Quantidade: </strong>
                            {element.QT_ENTRG}
                            <br />
                        </Typography>

                        <Typography variant="body2">
                            <strong>Cód numérico: </strong>
                            {element.CD_NUM}
                            <br />
                        </Typography>

                        <Typography variant="body2">
                            <strong>Data de emissão: </strong>
                            {element.DT_ENTRG}
                        </Typography>
                </Grid>
            </Grid>
        </Paper>
    );
}
